import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import * as React from "react";
import styled from "../../styled-components";
import { UniversalLink } from "../../components/UniversalLink/UniversalLink";
import { Flex } from "../Box/Flex";
import { TileHeader, TileText } from "./styled.elements";
var ThinTileWrapper = styled(UniversalLink)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  box-shadow: 0px 10px 30px 0px rgba(35, 35, 35, 0.1);\n  box-sizing: border-box;\n  transition: box-shadow 0.25s ease;\n  padding: 24px;\n  margin-bottom: 20px;\n  text-decoration: none;\n  width: 100%;\n  background-color: ", ";\n  background-image: ", ";\n  background-repeat: no-repeat;\n\n  :hover {\n    box-shadow: 0px 10px 100px 0px rgba(35, 35, 35, 0.2);\n  }\n\n  @media only screen and (min-width: ", ") {\n    width: calc(50% - 20px);\n    margin-right: 10px;\n    margin-left: 10px;\n  }\n\n  @media only screen and (min-width: ", ") {\n    width: 250px;\n  }\n\n  @media only screen and (min-width: ", ") {\n    width: 280px;\n  }\n\n  &.external-url {\n    :after {\n      display: none;\n    }\n  }\n"])), function (_ref) {
  var a = _ref.bgColor;
  return a || "#fff";
}, function (_ref2) {
  var a = _ref2.bgImage;
  return a ? "url(" + a + ")" : "none";
}, function (_ref3) {
  var a = _ref3.theme;
  return a.breakpoints.small;
}, function (_ref4) {
  var a = _ref4.theme;
  return a.breakpoints.medium;
}, function (_ref5) {
  var a = _ref5.theme;
  return a.breakpoints.large;
}),
    ThinTileIcon = styled.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  width: 90px;\n\n  @media only screen and (max-width: ", ") {\n    width: 80px;\n  }\n"])), function (_ref6) {
  var a = _ref6.theme;
  return a.breakpoints.medium;
}),
    ThinTileHeader = styled(TileHeader)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  font-size: 24px;\n  text-align: ", ";\n"])), function (_ref7) {
  var a = _ref7.align;
  return a || "center";
}),
    ThinTileText = styled(TileText)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  font-size: 18px;\n  line-height: 1.5;\n  flex-shrink: 0;\n  min-height: 3em;\n  text-align: ", ";\n  ", ";\n  @media only screen and (min-width: ", ") {\n    min-height: 6em;\n  }\n\n  @media only screen and (min-width: ", ") {\n    min-height: 4.5em;\n  }\n"])), function (_ref8) {
  var a = _ref8.align;
  return a || "center";
}, function (_ref9) {
  var a = _ref9.icon;
  return a ? "\n    display: -webkit-box;\n    -webkit-line-clamp: 8;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    line-clamp: 8;\n  " : "";
}, function (_ref10) {
  var a = _ref10.theme;
  return a.breakpoints.small;
}, function (_ref11) {
  var a = _ref11.theme;
  return a.breakpoints.medium;
});
export var ThinTile = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ThinTile, _React$Component);

  function ThinTile() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ThinTile.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        a = _this$props.header,
        b = _this$props.icon,
        c = _this$props.children,
        d = _this$props.to,
        e = _this$props.target,
        f = _this$props.headerAlign,
        g = _this$props.textAlign,
        h = _this$props.bgColor,
        i = _this$props.bgImage,
        j = _this$props.color,
        k = _this$props.className,
        l = _this$props.style,
        m = d ? ThinTileWrapper : ThinTileWrapper.withComponent("div");
    return /*#__PURE__*/React.createElement(m, {
      to: d,
      target: e,
      color: j,
      bgColor: h,
      bgImage: i,
      className: k,
      style: l
    }, (b || a) && /*#__PURE__*/React.createElement(Flex, {
      flexDirection: "column"
    }, b && /*#__PURE__*/React.createElement(Flex, {
      flexShrink: 0,
      height: {
        xs: "auto",
        small: "100px",
        medium: "110px"
      },
      alignItems: "center",
      justifyContent: "center",
      mb: "25px"
    }, /*#__PURE__*/React.createElement(ThinTileIcon, {
      src: b
    })), a && /*#__PURE__*/React.createElement(ThinTileHeader, {
      align: f,
      color: j,
      "data-cy": "Thin-" + a
    }, a)), c && /*#__PURE__*/React.createElement(ThinTileText, {
      icon: b,
      align: g,
      color: j
    }, c));
  };

  return ThinTile;
}(React.Component);